export default {
    data: () => ({
        translations: {
            notificationType: {
                el: "Notification Type",
                en: "Notification Type",
                it: "Notification Type"
            },
            total: {
                el: "Ολικό",
                en: "Total",
                it: "Totale"
            },
            date: {
                el: "Ημερομηνία",
                en: "Date",
                it: "Data"
            },
        }
    })
};
